import { GaugeCircle, ShieldCheck, Wrench } from "lucide-react";
import Booking from "./Booking";
import ServicePageFaqSection from "./ServicePageFaqSection";
import { useFaqPageJsonLd } from "@/hooks/useFaqPageJsonLd";

export default function MechanicsPage({ t }) {
  useFaqPageJsonLd(t.mechanicsPage.faq, "service-mechanics-faq");

  return (
    <article
      id="mechanics-page"
      data-testid="mechanics-page"
      className="bg-white border-b border-[#e2e6ec]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <header>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-4">
            {t.mechanicsPage.eyebrow}
          </div>
          <h1 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            {t.mechanicsPage.title}
          </h1>
          <p className="mt-6 max-w-3xl text-slate-600 leading-relaxed text-base sm:text-lg">
            {t.mechanicsPage.lead}
          </p>
          {t.mechanicsPage.secondary ? (
            <p className="mt-5 max-w-3xl text-slate-600 leading-relaxed text-base sm:text-lg">
              {t.mechanicsPage.secondary}
            </p>
          ) : null}
        </header>

        <div className="mt-8 border border-[#e2e6ec] bg-white overflow-hidden">
          <img
            src="/resources/mechanics-hero.png"
            alt={t.mechanicsPage.heroImageAlt}
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <section className="mt-12" aria-labelledby="mechanics-cards-heading">
          <h2
            id="mechanics-cards-heading"
            className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-2xl sm:text-3xl mb-8 max-w-4xl leading-tight"
          >
            {t.mechanicsPage.cardsSectionTitle}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <Wrench className="w-4 h-4" />
                {t.mechanicsPage.card1Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.mechanicsPage.card1Text}</p>
            </div>
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <GaugeCircle className="w-4 h-4" />
                {t.mechanicsPage.card2Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.mechanicsPage.card2Text}</p>
            </div>
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <ShieldCheck className="w-4 h-4" />
                {t.mechanicsPage.card3Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.mechanicsPage.card3Text}</p>
            </div>
          </div>
        </section>

        <ServicePageFaqSection
          headingId="mechanics-faq-heading"
          title={t.mechanicsPage.faqTitle}
          faq={t.mechanicsPage.faq}
        />

        <div className="mt-12">
          <Booking
            t={t}
            initialService={t.services.items.find((item) => item.code === "S/01")?.title || ""}
            copyOverrides={t.mechanicsPage.bookingCopy}
          />
        </div>
      </div>
    </article>
  );
}
